import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { APP_VERSION } from "@/config/version";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function LoginPage() {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API}/auth/login`, {
        username,
        password,
      });

      localStorage.setItem("token", response.data.token);
      localStorage.setItem("user", JSON.stringify(response.data.user));

      toast.success("ログイン成功");

      // Redirect based on role
      const role = response.data.user.role;
      if (role === "admin") navigate("/admin");
      else if (role === "store") navigate("/store");
    } catch (error) {
      toast.error("ログインに失敗しました");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex bg-white">
      {/* Left side - Logo image */}
      <div
        className="hidden lg:flex lg:w-1/2 items-center justify-center p-12 bg-white"
      >
        <img
          src="/assets/login-bg.png"
          alt="やさまるポータル"
          className="max-w-full max-h-[80vh] w-auto h-auto object-contain"
        />
      </div>

      {/* Right side - Form */}
      <div
        className="w-full lg:w-1/2 flex flex-col items-center justify-center p-8"
        style={{ backgroundColor: "#F5FAF0" }}
      >
        <div className="w-full max-w-md flex flex-col items-center">
          {/* Mobile-only logo above the form */}
          <img
            src="/assets/yasamaru-logo.png"
            alt="やさまるポータル"
            className="lg:hidden h-40 w-auto mb-6 object-contain"
          />

          <div className="w-full bg-white rounded-lg shadow-lg p-8 border border-slate-100">
            <form onSubmit={handleLogin} className="space-y-6">
              <div>
                <Label htmlFor="username" className="text-sm font-medium text-slate-700">
                  ユーザー名
                </Label>
                <Input
                  id="username"
                  data-testid="login-username-input"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="mt-1 h-10 rounded-sm border-slate-300"
                  required
                />
              </div>

              <div>
                <Label htmlFor="password" className="text-sm font-medium text-slate-700">
                  パスワード
                </Label>
                <Input
                  id="password"
                  data-testid="login-password-input"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="mt-1 h-10 rounded-sm border-slate-300"
                  required
                />
              </div>

              <Button
                type="submit"
                data-testid="login-submit-button"
                disabled={loading}
                className="w-full bg-slate-900 text-white hover:bg-slate-800 rounded-sm h-11 font-medium"
              >
                {loading ? "ログイン中..." : "ログイン"}
              </Button>
            </form>
            
            {/* Version */}
            <div className="mt-8 text-center text-xs text-slate-400">
              v{APP_VERSION}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}